// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_country from "../../commonapis/gen/buhta_common_v1_country.js";
import * as Buhta_commonapis__Buhta_common_v1_org_type from "../../commonapis/gen/buhta_common_v1_org_type.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const OrgTypeItem = Caml_module.init_mod([
      "proto/dictapis/gen/buhta_dict_v1_org_type_service.ml",
      394,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetOrgTypesRequest = Caml_module.init_mod([
      "proto/dictapis/gen/buhta_dict_v1_org_type_service.ml",
      460,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetOrgTypesResponse = Caml_module.init_mod([
      "proto/dictapis/gen/buhta_dict_v1_org_type_service.ml",
      521,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.dict.v1.OrgTypeItem";
}

function make(type$pOpt, nameOpt, shortOpt, param) {
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0);
  const name = nameOpt !== undefined ? nameOpt : "";
  const $$short = shortOpt !== undefined ? shortOpt : "";
  return {
          "type'": type$p,
          name: name,
          short: $$short
        };
}

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "type",
            "type"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
          Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_short = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "short",
            "short"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge(t1, t2) {
  return {
          "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
          name: Curry._2(merge_name, t1.name, t2.name),
          short: Curry._2(merge_short, t1.short, t2.short)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "type",
                    "type"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
                  Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "name",
                        "name"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "short",
                            "short"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param["type'"], param.name, param.short);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(type$p, name, $$short) {
  return {
          "type'": type$p,
          name: name,
          short: $$short
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1.OrgTypeItem", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param["type'"], param.name, param.short);
  };
}

function constructor$1(type$p, name, $$short) {
  return {
          "type'": type$p,
          name: name,
          short: $$short
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1.OrgTypeItem", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, OrgTypeItem, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.dict.v1.GetOrgTypesRequest";
}

function make$1(countryOpt, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  return {
          country: country
        };
}

const merge_country = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "country",
            "country"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
          Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
        ]));

function merge$1(t1, t2) {
  return {
          country: Curry._2(merge_country, t1.country, t2.country)
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "country",
                    "country"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
                  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.country);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(country) {
  return {
          country: country
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1.GetOrgTypesRequest", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.country);
  };
}

function constructor$3(country) {
  return {
          country: country
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1.GetOrgTypesRequest", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetOrgTypesRequest, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.dict.v1.GetOrgTypesResponse";
}

function make$2(countryOpt, typesOpt, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  const types = typesOpt !== undefined ? typesOpt : /* [] */0;
  return {
          country: country,
          types: types
        };
}

const merge_country$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "country",
            "country"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
          Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
        ]));

const merge_types = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "types",
            "types"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: OrgTypeItem.name,
                make: OrgTypeItem.make,
                from_proto: OrgTypeItem.from_proto,
                from_proto_exn: OrgTypeItem.from_proto_exn,
                to_proto: OrgTypeItem.to_proto,
                to_proto$p: OrgTypeItem.to_proto$p,
                merge: OrgTypeItem.merge,
                to_json: OrgTypeItem.to_json,
                from_json_exn: OrgTypeItem.from_json_exn,
                from_json: OrgTypeItem.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$2(t1, t2) {
  return {
          country: Curry._2(merge_country$1, t1.country, t2.country),
          types: Curry._2(merge_types, t1.types, t2.types)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "country",
                    "country"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
                  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "types",
                        "types"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: OrgTypeItem.name,
                            make: OrgTypeItem.make,
                            from_proto: OrgTypeItem.from_proto,
                            from_proto_exn: OrgTypeItem.from_proto_exn,
                            to_proto: OrgTypeItem.to_proto,
                            to_proto$p: OrgTypeItem.to_proto$p,
                            merge: OrgTypeItem.merge,
                            to_json: OrgTypeItem.to_json,
                            from_json_exn: OrgTypeItem.from_json_exn,
                            from_json: OrgTypeItem.from_json
                          }),
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.country, param.types);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(country, types) {
  return {
          country: country,
          types: types
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1.GetOrgTypesResponse", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.country, param.types);
  };
}

function constructor$5(country, types) {
  return {
          country: country,
          types: types
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1.GetOrgTypesResponse", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetOrgTypesResponse, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

const getOrgTypes_0 = {
  name: GetOrgTypesRequest.name,
  make: GetOrgTypesRequest.make,
  from_proto: GetOrgTypesRequest.from_proto,
  from_proto_exn: GetOrgTypesRequest.from_proto_exn,
  to_proto: GetOrgTypesRequest.to_proto,
  to_proto$p: GetOrgTypesRequest.to_proto$p,
  merge: GetOrgTypesRequest.merge,
  to_json: GetOrgTypesRequest.to_json,
  from_json_exn: GetOrgTypesRequest.from_json_exn,
  from_json: GetOrgTypesRequest.from_json
};

const getOrgTypes_1 = {
  name: GetOrgTypesResponse.name,
  make: GetOrgTypesResponse.make,
  from_proto: GetOrgTypesResponse.from_proto,
  from_proto_exn: GetOrgTypesResponse.from_proto_exn,
  to_proto: GetOrgTypesResponse.to_proto,
  to_proto$p: GetOrgTypesResponse.to_proto$p,
  merge: GetOrgTypesResponse.merge,
  to_json: GetOrgTypesResponse.to_json,
  from_json_exn: GetOrgTypesResponse.from_json_exn,
  from_json: GetOrgTypesResponse.from_json
};

const getOrgTypes = [
  getOrgTypes_0,
  getOrgTypes_1
];

const V1_OrgTypeService = {
  GetOrgTypes: {
    name: "/buhta.dict.v1.OrgTypeService/GetOrgTypes",
    package_name: "buhta.dict.v1",
    service_name: "OrgTypeService",
    method_name: "GetOrgTypes",
    $$Request: {
      name: GetOrgTypesRequest.name,
      make: GetOrgTypesRequest.make,
      from_proto: GetOrgTypesRequest.from_proto,
      from_proto_exn: GetOrgTypesRequest.from_proto_exn,
      to_proto: GetOrgTypesRequest.to_proto,
      to_proto$p: GetOrgTypesRequest.to_proto$p,
      merge: GetOrgTypesRequest.merge,
      to_json: GetOrgTypesRequest.to_json,
      from_json_exn: GetOrgTypesRequest.from_json_exn,
      from_json: GetOrgTypesRequest.from_json
    },
    $$Response: {
      name: GetOrgTypesResponse.name,
      make: GetOrgTypesResponse.make,
      from_proto: GetOrgTypesResponse.from_proto,
      from_proto_exn: GetOrgTypesResponse.from_proto_exn,
      to_proto: GetOrgTypesResponse.to_proto,
      to_proto$p: GetOrgTypesResponse.to_proto$p,
      merge: GetOrgTypesResponse.merge,
      to_json: GetOrgTypesResponse.to_json,
      from_json_exn: GetOrgTypesResponse.from_json_exn,
      from_json: GetOrgTypesResponse.from_json
    }
  },
  getOrgTypes: getOrgTypes
};

const V1 = {
  OrgTypeItem: OrgTypeItem,
  GetOrgTypesRequest: GetOrgTypesRequest,
  GetOrgTypesResponse: GetOrgTypesResponse,
  OrgTypeService: V1_OrgTypeService
};

const Dict = {
  V1: V1
};

const Buhta = {
  Dict: Dict
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* OrgTypeItem Not a pure module */
